import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { CompanyTopContainer } from "../features/company/top";

export const TopPage = () => {
	return (
		<PageMeta title="" url={PATHS.TOP}>
			<CompanyTopContainer />
		</PageMeta>
	);
};

TopPage.displayName = "TopPage";
